const OPT_OUT_CONFIRMATION_HTML = `
  <div class="toast-container position-fixed bottom-0 start-0 p-3" style="z-index: 1090;">
    <div
      id="onetrust-consent-toast"
      class="toast align-items-center border-0 alert alert-success"
      role="alert"
      aria-live="assertive"
      aria-atomic="true"
    >
      <div class="d-flex">
        <div class="toast-body">
          <strong>Opt-Out Request Honored</strong>
          <div>Your cookie preferences have been updated successfully.</div>
        </div>
        <button
          type="button"
          class="btn-close me-2 m-auto"
          data-bs-dismiss="toast"
          aria-label="Close"
        ></button>
      </div>
    </div>
  </div>
`;
const getOrCreateOptOutToastElements = () => {
    const $existingToast = document.querySelector('#onetrust-consent-toast');
    if ($existingToast)
        return $existingToast;
    const $wrapper = document.createElement('div');
    $wrapper.innerHTML = OPT_OUT_CONFIRMATION_HTML.trim();
    const $container = $wrapper.firstElementChild;
    if (!$container)
        return null;
    document.body.append($container);
    const $toast = $container.firstElementChild;
    return $toast !== null && $toast !== void 0 ? $toast : null;
};
let optOutToastInstance = null;
export const getOrCreateOptOutToastInstance = () => {
    var _a;
    if (optOutToastInstance)
        return optOutToastInstance;
    if (!((_a = bootstrap === null || bootstrap === void 0 ? void 0 : bootstrap.Toast) === null || _a === void 0 ? void 0 : _a.getOrCreateInstance))
        return null;
    const $optOutToast = getOrCreateOptOutToastElements();
    const newOptOutToastInstance = $optOutToast
        ? bootstrap.Toast.getOrCreateInstance($optOutToast, {
            autohide: true,
        })
        : null;
    optOutToastInstance = newOptOutToastInstance;
    return optOutToastInstance;
};
